import { UserProvider } from "@/components/UserProvider";
import { getUserSessionQueryOptions } from "@/lib/data/react-query/auth/auth";
import { isAuthenticated } from "@/lib/utils/auth";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { Suspense, useEffect } from "react";
import LawWorksLoader from "../LawWorksLoader/LawWorksLoader";
import { AppSidebar } from "../AppSidebar/AppSidebar";
import { FullPageCard } from "../FullPageCard/FullPageCard";

export const GlobalNotFound = () => {
  const { data: session } = useSuspenseQuery(getUserSessionQueryOptions());
  const navigate = useNavigate();
  useEffect(() => {
    if (!isAuthenticated({ session })) {
      const path = window.location.pathname;
      void navigate({ to: path ? `/login?redirect=${path}` : "/login" });
    }
  }, [session, navigate]);

  return (
    <div className="flex w-full">
      {isAuthenticated({ session }) && (
        <div className="flex w-full">
          <Suspense fallback={<LawWorksLoader />}>
            <UserProvider>
              <div className="flex w-full">
                <AppSidebar />
                <FullPageCard
                  title="Page not found"
                  backButtonLink="/"
                  backButtonTitle="Back to home"
                >
                  <div>{`Oops! The page you're looking for doesn't exist.`}</div>
                </FullPageCard>
              </div>
            </UserProvider>
          </Suspense>
        </div>
      )}
    </div>
  );
};
